module.exports = __webpack_public_path__ + "static/media/sem-logo.0486dcb2.png";